// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    classNames,
    Alert,
    Button,
    Fragment,
    Icon,
    List,
    Media,
    MediaSection,
    Panel,
    PropTypes,
    Status,
    Translate,
} from '@plesk/ui-library';
import Available from './Available';

const Disk = ({ data, onCleanUp, isProcessing, ...props }) => (
    <Panel title={<Translate content="Disk.title" />} {...props}>
        <Media image={<Icon src="images/disk-space.png" size="lg" alt="Disk Space" />}>
            <MediaSection>
                <Translate content="Disk.description" />
            </MediaSection>
            {data.error ? (
                <MediaSection>
                    <Alert intent="danger">
                        <Status
                            intent="danger"
                            bottomAddon={data.error}
                        >
                            <Translate content="Disk.loadingError" />
                        </Status>
                    </Alert>
                </MediaSection>
            ) : (
                <Fragment>
                    <MediaSection>
                        <List
                            columns={[{
                                key: 'volume',
                                title: <Translate content="Disk.volume" />,
                            }, {
                                key: 'free',
                                title: <Translate content="Disk.free" />,
                                render: ({ free, total, requires }) => // eslint-disable-line react/display-name,react/prop-types
                                    (
                                        <Available free={free} total={total} min={requires} />
                                    ),
                            }]}
                            rowKey="volume"
                            data={data}
                        />
                    </MediaSection>
                    <MediaSection>
                        <Translate content="Disk.recommend" />
                    </MediaSection>
                    <MediaSection>
                        <Button intent="primary" onClick={onCleanUp} state={isProcessing ? 'loading' : null} id="disk-cleanup">
                            <Translate content="Disk.cleanUp" />
                        </Button>
                    </MediaSection>
                </Fragment>
            )}
        </Media>
    </Panel>
);

Disk.propTypes = {
    data: PropTypes.array.isRequired,
    onCleanUp: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
};

export default Disk;



// WEBPACK FOOTER //
// ./app/repair/Disk.js